import { consentManagement } from './consent-management-de.i18n';

export const de = {
  consentManagement
};
